import React from 'react'
import { Typography } from "@mui/material";

const PageParagraph = ({p}) => {
  return (
    <Typography align='center' variant="h4">{p}</Typography>
  )
}

export default PageParagraph;